import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import type { RdCatalogEquipment } from '@/services/quotes/rd-equipamentos/types';
import { useQuery } from '@tanstack/react-query';

/**
 * Autocomplete do catálogo de equipamentos RD (`GET /equipment-catalog`).
 * Só busca a partir de 2 caracteres — `term` já deve chegar debounced
 * (200ms, via `useDebouncedValue`) do chamador, espelhando o autocomplete do
 * demo (`rd_wizard.js`).
 */
export function useRdEquipmentSearch(term: string) {
  return useQuery<RdCatalogEquipment[]>({
    queryKey: ['rd-equipment-catalog', term],
    queryFn: async () => {
      const response = await rdEquipamentosService.searchEquipment(term);
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao buscar equipamentos');
      }

      return response.data;
    },
    enabled: term.length >= 2,
  });
}
